module.exports = __webpack_public_path__ + "img/logo.194e35c5.png";